// extracted by mini-css-extract-plugin
module.exports = {"layout":"_tenant__layout__NHlv4","clipped-content":"_tenant__clipped-content__QOSwQ"};